module.exports = __webpack_public_path__ + "static/media/01_after.71967028.jpg";